import { Grid, Typography, Box, Button } from "@mui/material";
import React, { useState } from "react";
import TextEditor from "../../../Components/TextEditor/TextEditor";
import FileUpload from "../../../Components/FileUpload/FileUpload";
import MultiCheckBoxes from "../../../Components/MultiCheckBox/MultiCheckBoxes";
import MuiButton from "../../../Components/Button/Button";
import MuiInputField from "../../../Components/InputField/InputField";
import DropDown from "../../../Components/DropDown/DropDown";
import MultiSelectDropDown from "../../../Components/DropDown/MultiSelectDropDown";
import { checkNumberLimit, downloadBase64File } from "../../../Utils/helper";
import document from "../../../Assets/Hospital/doc.svg";
import { TextView } from "../../../Components/TextView";
import { EditableList } from "../../../Components/EditableList";
import DisApproveModal from "../../../Components/ModalPopUp/DisApproveModal";

import useHospitalAdd from "./useHospitalAdd";
import { useSearchParams } from "react-router-dom";

export function DetailChip(props) {
  return (
    <Box
      sx={{
        backgroundColor: props.color || "#e6f0f5",
        display: "flex",
        width: "fit-content",
        flexDirection: "row",
        padding: "7px 13px 7px 8px",
        borderRadius: props.borderRadius || "5px",
        border: props.border || "1px solid #c0d9e4",
        marginX: "7px",
        marginY: "7px",
        alignItems: "center",
      }}
    >
      <TextView
        style={{
          fontSize: "14px",
          fontWeight: 500,
          // textTransform: "capitalize",
        }}
      >
        {props.link ? (
          <a
            style={{ textDecoration: "none", color: props.value ? "blue" : "" }}
            target="_blank"
            href={props.value}
          >
            {props.value || "N/A"}{" "}
          </a>
        ) : (
          props.value || "N/A"
        )}
      </TextView>
    </Box>
  );
}

export const DetailTab = (
  state,
  doc,
  setDoc,
  interDoc,
  setInterDoc,
  domDoc,
  setDomDoc,
  logo,
  setLogo,
  setInteriorImage,
  interiorImage,
  treatments,
  getTreatments
) => {
  const urls = state?.details?.referenceLinks?.split(",");
  // const { setShowDuplicateModal, showDuplicateModal, handleDuplicate } =
  //   useHospitalAdd();
  const [query] = useSearchParams();
  const from = query.get("from");
  const [disApproveModal, setDisApproveModal] = useState(false);

  const handleControl = (status) => {
    if (status === "REJECTED") {
      setDisApproveModal(true);
      if (!state?.rejectedReason) {
        state?.setError(true);
      } else {
        setDisApproveModal(false);
        state?.setError(false);
      }
    }
    state?.handleDisapprove(status);
  };

  return (
    <>
      <Box
        border={state.isEditable ? "none" : "1px solid lightgrey"}
        borderRadius={2}
        padding={state.isEditable ? "0px" : "40px"}
      >
        <Grid
          container
          item
          display={"flex"}
          direction="row"
          lg={12}
          // justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid item lg={8}>
            <MultiCheckBoxes
              isDisabled={state.isEditable}
              setCheckedItems={state.setCheckedItems}
              setCheckedItemsId={state.setCheckedItemsId}
              checkedItems={state.checkedItems}
              items={state.items}
            />
          </Grid>
          {(state?.isLive && state?.id) && <Grid item lg={4} >
            <MuiButton
              onClick={() => handleControl('REJECTED')}
              padding="10px 52px"
              viewHeight="45px"
              bgColor="#17dfba"
              borderRadius="5px"
              title={"Disapprove"}
            />
          </Grid>}
        </Grid>
        {state.isEditable && (
          <Typography
            sx={{
              fontWeight: "500",
              fontSize: "16px",
              color: "#4c5a6a",
              paddingTop: "20px",
              fontFamily: "poppins",
            }}
          >
            Add General Info
          </Typography>
        )}
        <Grid
          container
          item
          marginTop={state.isEditable ? "15px" : "30px"}
          height={"80px"}
          lg={12}
          justifyContent={"space-between"}
          alignItems={"flex-start"}
        >
          <Grid item lg={3.8}>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                color: "#4c5a6a",
                paddingBottom: "7px",
                fontFamily: "poppins",
              }}
            >
              Hospital Name
            </Typography>
            {state.isEditable ? (
              <>
                <MuiInputField
                  value={state?.details?.name}
                  onChange={(event) => {
                    state.setDetails((s) => ({
                      ...s,
                      name: event.target.value,
                    }));
                  }}
                  onBlur={(event) => {
                    if (!event.target.value) {
                      state.setIsHospitalValid((s) => ({
                        ...s,
                        isName: true,
                      }));
                    } else {
                      state.setIsHospitalValid((s) => ({
                        ...s,
                        isName: false,
                      }));
                    }
                  }}
                  placeHolder={"Enter the hospital name"}
                />
                {state.isHospitalValid.isName && (
                  <Typography fontSize="14px" my={2} color="red">
                    Hospital name is mandatory
                  </Typography>
                )}
                {state.duplicateName && (
                  <Typography fontSize="14px" mt={1} color="red">
                    Hospital name already exists
                  </Typography>
                )}
              </>
            ) : (
              <TextView>{state?.details?.name}</TextView>
            )}
          </Grid>
          <Grid item lg={3.8}>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                color: "#4c5a6a",
                paddingBottom: "7px",
              }}
            >
              Choose Location
            </Typography>
            {state.isEditable ? (
              <>
                <DropDown
                  placeHolder={"Choose location"}
                  viewHeight={"44px"}
                  borderRadius={"5px"}
                  bgColor="white"
                  border="2px solid #e9eff7"
                  viewWidth="100%"
                  value={state.details.location}
                  data={state.locations}
                  onBlur={(e, value) => {
                    if (!e.target.value) {
                      state.setIsHospitalValid((s) => ({
                        ...s,
                        isLocation: true,
                      }));
                    } else {
                      state.setIsHospitalValid((s) => ({
                        ...s,
                        isLocation: false,
                      }));
                    }
                  }}
                  handleSelected={(e, value) => {
                    state.setDetails((s) => ({ ...s, location: value }));
                  }}
                />
                {state.isHospitalValid.isLocation && (
                  <Typography fontSize="14px" mt={1} color="red">
                    Hospital location is mandatory
                  </Typography>
                )}
              </>
            ) : (
              <TextView>{state?.details?.location?.name}</TextView>
            )}
          </Grid>
          <Grid item lg={3.8}>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                color: "#4c5a6a",
                paddingBottom: "7px",
              }}
            >
              Add Address
            </Typography>
            {state.isEditable ? (
              <MuiInputField
                value={state?.details?.address}
                onChange={(event) => {
                  state.setDetails((s) => ({
                    ...s,
                    address: event.target.value,
                  }));
                }}
                placeHolder={"Enter the hospital address"}
              />
            ) : (
              <TextView>{state?.details?.address}</TextView>
            )}
          </Grid>
        </Grid>
        {state.isEditable && (
          <Typography
            sx={{
              fontWeight: "500",
              fontSize: "16px",
              color: "#4c5a6a",
              paddingTop: "20px",
              fontFamily: "poppins",
            }}
          >
            Add Hospital Assets
          </Typography>
        )}
        <Grid
          container
          item
          marginTop={state.isEditable ? "15px" : "30px"}
          lg={12}
          justifyContent={"space-between"}
          alignItems={"flex-start"}
        >
          <Grid item sm={6} lg={3.8} xl={2.8}>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                color: "#4c5a6a",
                paddingBottom: "7px",
              }}
            >
              Upload Hospital Doc
            </Typography>

            {state.isEditable ? (
              <FileUpload
                id="hospital"
                doc={doc}
                setDoc={setDoc}
                type="hospitalDoc"
              />
            ) : (
              <Grid
                sx={{
                  display: "flex",
                  overflowY: "hidden",
                  overflowX: "auto",
                  "&::-webkit-scrollbar": {
                    height: "5px",
                    width: "10px",
                    backgroundColor: "lightgray",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "grey",
                    borderRadius: "30px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "grey",
                  },
                }}
              >
                {doc.document.map((val, i) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "54px",
                        height: "54px",
                        border: "1px solid lightgray",
                        borderRadius: "10px",
                        marginLeft: "10px",
                      }}
                      onClick={() =>
                        downloadBase64File(
                          `data:${val.documentType};base64,${val.document}`,
                          val.documentName
                        )
                      }
                    >
                      <Box
                        component="img"
                        src={document}
                        sx={{
                          width: "40px",
                          height: "40px",
                          objectFit: "contain",
                          ":hover": { transform: "scale(1.5)" },
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  );
                })}
              </Grid>
            )}

            {state.isEditable && (
              <EditableList
                onUploadClick={(val, index) => {
                  const updatedImages = [...doc.hospitalDoc];
                  updatedImages.splice(index, 1);
                  setDoc((s) => ({
                    ...s,
                    hospitalDoc: updatedImages,
                  }));
                }}
                onResponseClick={(val, index) => {
                  const updatedImages = [...doc.document];
                  updatedImages.splice(index, 1);
                  setDoc((s) => ({
                    ...s,
                    document: updatedImages,
                    documentIds: [...s.documentIds, val.documentId],
                  }));
                }}
                responseDoc={doc.document}
                uploadDoc={doc?.hospitalDoc}
              />
            )}
          </Grid>

          <Grid item sm={6} lg={3.8} xl={2.8}>
            <Grid item lg={12}>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "#4c5a6a",
                  paddingBottom: "7px",
                  paddingTop: "10px",
                }}
              >
                Upload Hospital Logo
              </Typography>
              {state.isEditable ? (
                <FileUpload
                  id="logo"
                  doc={logo}
                  setDoc={setLogo}
                  type="agreementDoc"
                />
              ) : (
                <Grid
                  sx={{
                    display: "flex",
                    overflowY: "hidden",
                    overflowX: "auto",
                    "&::-webkit-scrollbar": {
                      height: "5px",
                      width: "10px",
                      backgroundColor: "lightgray",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "grey",
                      borderRadius: "30px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "grey",
                    },
                  }}
                >
                  {logo?.document?.map((val, i) => {
                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "54px",
                          height: "54px",
                          border: "1px solid lightgray",
                          borderRadius: "10px",
                          marginLeft: "10px",
                        }}
                        onClick={() =>
                          downloadBase64File(
                            `data:${val.documentType};base64,${val.document}`,
                            val.documentName
                          )
                        }
                      >
                        <Box
                          component="img"
                          src={`data:${val.documentType};base64,${val.document}`}
                          sx={{
                            width: "40px",
                            height: "40px",
                            objectFit: "contain",
                            ":hover": { transform: "scale(1.5)" },
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    );
                  })}
                </Grid>
              )}
              {state.isEditable && (
                <EditableList
                  onResponseClick={(val, index) => {
                    const updatedImages = [...logo.document];
                    updatedImages.splice(index, 1);
                    setLogo((s) => ({
                      ...s,
                      document: updatedImages,
                      documentIds: [...s.documentIds, val.documentId],
                    }));
                  }}
                  onUploadClick={(val, index) => {
                    console.log("uploaded");
                    const updatedImages = [...logo.agreementDoc];
                    updatedImages.splice(index, 1);
                    setLogo((s) => ({
                      ...s,
                      agreementDoc: updatedImages,
                    }));
                  }}
                  responseDoc={logo?.document}
                  uploadDoc={logo?.agreementDoc}
                />
              )}
            </Grid>
          </Grid>

          <Grid item sm={6} lg={3.8} xl={2.8}>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                color: "#4c5a6a",
                paddingBottom: "7px",
              }}
            >
              Upload Hospital Exterior Image
            </Typography>
            {state?.isEditable ? (
              <FileUpload
                id="image"
                doc={doc}
                setDoc={setDoc}
                type="hospitalImage"
              />
            ) : (
              <div
                style={{
                  display: "flex",
                }}
              >
                {doc?.image?.map((val) => {
                  return (
                    <Grid height={100} width={100}>
                      <Box
                        component="img"
                        src={`data:${val.documentType};base64,${val.document}`}
                        sx={{
                          width: "54px",
                          height: "54px",
                          objectFit: "fill",
                          border: "1px solid lightgray",
                          borderRadius: "10px",
                        }}
                      />
                    </Grid>
                  );
                })}
              </div>
            )}

            {state.isEditable && (
              <EditableList
                onResponseClick={(list, index) => {
                  const updatedImages = [...doc.image];
                  updatedImages.splice(index, 1);
                  setDoc((s) => ({
                    ...s,
                    image: updatedImages,
                    documentIds: [...s.documentIds, list.documentId],
                  }));
                }}
                onUploadClick={(val, index) => {
                  const updatedImages = [...doc.hospitalImage];
                  updatedImages.splice(index, 1);
                  setDoc((s) => ({
                    ...s,
                    hospitalImage: updatedImages,
                  }));
                }}
                responseDoc={doc?.image}
                uploadDoc={doc?.hospitalImage}
              />
            )}
          </Grid>

          <Grid item sm={6} lg={3.8} xl={2.8}>
            <Grid item lg={12}>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "#4c5a6a",
                  paddingBottom: "7px",
                  paddingTop: "10px",
                }}
              >
                Upload Hospital Interior Image
              </Typography>
              {state.isEditable ? (
                <FileUpload
                  id="exterior"
                  doc={interiorImage}
                  setDoc={setInteriorImage}
                  type="agreementDoc"
                />
              ) : (
                <Grid
                  sx={{
                    display: "flex",
                    overflowY: "hidden",
                    overflowX: "auto",
                    "&::-webkit-scrollbar": {
                      height: "5px",
                      width: "10px",
                      backgroundColor: "lightgray",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "grey",
                      borderRadius: "30px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "grey",
                    },
                  }}
                >
                  {interiorImage?.document?.map((val, i) => {
                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "54px",
                          height: "54px",
                          border: "1px solid lightgray",
                          borderRadius: "10px",
                          marginLeft: "10px",
                        }}
                        onClick={() =>
                          downloadBase64File(
                            `data:${val.documentType};base64,${val.document}`,
                            val.documentName
                          )
                        }
                      >
                        <Box
                          component="img"
                          src={`data:${val.documentType};base64,${val.document}`}
                          sx={{
                            width: "40px",
                            height: "40px",
                            objectFit: "contain",
                            ":hover": { transform: "scale(1.5)" },
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    );
                  })}
                </Grid>
              )}
              {state.isEditable && (
                <EditableList
                  onResponseClick={(val, index) => {
                    const updatedImages = [...interiorImage.document];
                    updatedImages.splice(index, 1);
                    setInteriorImage((s) => ({
                      ...s,
                      document: updatedImages,
                      documentIds: [...s.documentIds, val.documentId],
                    }));
                  }}
                  onUploadClick={(val, index) => {
                    const updatedImages = [...interiorImage.agreementDoc];
                    updatedImages.splice(index, 1);
                    setInteriorImage((s) => ({
                      ...s,
                      agreementDoc: updatedImages,
                    }));
                  }}
                  responseDoc={interiorImage?.document}
                  uploadDoc={interiorImage?.agreementDoc}
                />
              )}
            </Grid>
          </Grid>
        </Grid>

        {state.isEditable && (
          <Typography
            sx={{
              fontWeight: "500",
              fontSize: "16px",
              color: "#4c5a6a",
              paddingTop: "20px",
              fontFamily: "poppins",
            }}
          >
            Add Agreement Details
          </Typography>
        )}
        <Grid
          container
          item
          marginTop={state.isEditable ? "15px" : "30px"}
          lg={12}
          justifyContent={"space-between"}
          alignItems={"flex-start"}
        >
          <Grid item sm={6}>
            <Grid item lg={12}>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "#4c5a6a",
                  paddingBottom: "7px",
                  paddingTop: "10px",
                }}
              >
                Upload Domestic Agreements
              </Typography>
              {state.isEditable ? (
                <FileUpload
                  id="agreementDom"
                  doc={domDoc}
                  setDoc={setDomDoc}
                  type="agreementDoc"
                />
              ) : (
                <Grid
                  sx={{
                    display: "flex",
                    overflowY: "hidden",
                    overflowX: "auto",
                    "&::-webkit-scrollbar": {
                      height: "5px",
                      width: "10px",
                      backgroundColor: "lightgray",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "grey",
                      borderRadius: "30px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "grey",
                    },
                  }}
                >
                  {Array.isArray(domDoc?.document)
                    ? domDoc?.document?.map((val, i) => {
                      return (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "54px",
                            height: "54px",
                            border: "1px solid lightgray",
                            borderRadius: "10px",
                            marginLeft: "10px",
                          }}
                          onClick={() =>
                            downloadBase64File(
                              `data:${val?.documentType};base64,${val?.document}`,
                              val?.documentName
                            )
                          }
                        >
                          <Box
                            component="img"
                            src={document}
                            sx={{
                              width: "40px",
                              height: "40px",
                              objectFit: "contain",
                              ":hover": { transform: "scale(1.5)" },
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      );
                    })
                    : null}
                </Grid>
              )}
              {state?.isEditable && (
                <EditableList
                  onResponseClick={(val, index) => {
                    const updatedImages = [...domDoc?.document];
                    updatedImages.splice(index, 1);
                    setDomDoc((s) => ({
                      ...s,
                      document: updatedImages,
                      documentIds: [...s?.documentIds, val?.documentId],
                    }));
                  }}
                  onUploadClick={(val, index) => {
                    console.log("uploaded");
                    const updatedImages = [...domDoc?.agreementDoc];
                    updatedImages.splice(index, 1);
                    setDomDoc((s) => ({
                      ...s,
                      agreementDoc: updatedImages,
                    }));
                  }}
                  responseDoc={domDoc?.document}
                  uploadDoc={domDoc?.agreementDoc}
                />
              )}
            </Grid>
          </Grid>

          {/* <DuplicateCheckModal
            showDuplicateModal={showDuplicateModal}
            setShowDuplicateModal={setShowDuplicateModal}
          /> */}

          <Grid item sm={6}>
            <Grid item lg={12}>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "#4c5a6a",
                  paddingBottom: "7px",
                  paddingTop: "10px",
                }}
              >
                Upload International Agreement
              </Typography>
              {state.isEditable ? (
                <FileUpload
                  id="agreementInter"
                  doc={interDoc}
                  setDoc={setInterDoc}
                  type="agreementDoc"
                />
              ) : (
                <Grid
                  sx={{
                    display: "flex",
                    overflowY: "hidden",
                    overflowX: "auto",
                    "&::-webkit-scrollbar": {
                      height: "5px",
                      width: "10px",
                      backgroundColor: "lightgray",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "grey",
                      borderRadius: "30px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "grey",
                    },
                  }}
                >
                  {interDoc?.document?.map((val, i) => {
                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "54px",
                          height: "54px",
                          border: "1px solid lightgray",
                          borderRadius: "10px",
                          marginLeft: "10px",
                        }}
                        onClick={() =>
                          downloadBase64File(
                            `data:${val.documentType};base64,${val.document}`,
                            val.documentName
                          )
                        }
                      >
                        <Box
                          component="img"
                          src={document}
                          sx={{
                            width: "40px",
                            height: "40px",
                            objectFit: "contain",
                            ":hover": { transform: "scale(1.5)" },
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    );
                  })}
                </Grid>
              )}
              {state.isEditable && (
                <EditableList
                  onResponseClick={(val, index) => {
                    const updatedImages = [...interDoc.document];
                    updatedImages.splice(index, 1);
                    setInterDoc((s) => ({
                      ...s,
                      document: updatedImages,
                      documentIds: [...s.documentIds, val.documentId],
                    }));
                  }}
                  onUploadClick={(val, index) => {
                    console.log("uploaded");
                    const updatedImages = [...interDoc.agreementDoc];
                    updatedImages.splice(index, 1);
                    setInterDoc((s) => ({
                      ...s,
                      agreementDoc: updatedImages,
                    }));
                  }}
                  responseDoc={interDoc?.document}
                  uploadDoc={interDoc?.agreementDoc}
                />
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          item
          height={"80px"}
          lg={14}
          alignItems={"space-between"}
          marginTop={"30px"}
        >
          <Grid marginRight={"10px"} item sm={3}>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                color: "#4c5a6a",
                paddingBottom: "7px",
              }}
            >
              Contact Number
            </Typography>
            {state.isEditable ? (
              <>
                <MuiInputField
                  prefix={"+91"}
                  type="number"
                  maxlength={10}
                  value={state?.details?.contactNumber}
                  onChange={(event) => {
                    const isNumber = checkNumberLimit(event.target.value);
                    if (isNumber) {
                      state.setDetails((s) => ({
                        ...s,
                        contactNumber: event.target.value,
                      }));
                    }
                  }}
                  onBlur={(event) => {
                    if (!event.target.value) {
                      state.setIsHospitalValid((s) => ({
                        ...s,
                        isContact: true,
                      }));
                    } else {
                      state.setIsHospitalValid((s) => ({
                        ...s,
                        isContact: false,
                      }));
                    }
                  }}
                  placeHolder={"Add phonenumber"}
                />
                {state.isHospitalValid.isContact && (
                  <Typography fontSize="14px" mt={1} color="red">
                    Hospital contact number is mandatory
                  </Typography>
                )}
              </>
            ) : (
              <TextView>{"+91 " + state?.details?.contactNumber}</TextView>
            )}
          </Grid>
          <Grid item sm={3}>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                color: "#4c5a6a",
                paddingBottom: "7px",
              }}
            >
              Alternate Contact number (Optional)
            </Typography>
            {state.isEditable ? (
              <MuiInputField
                prefix={"+91"}
                type="number"
                maxLength={10}
                value={state?.details?.alternateContactNumber}
                onChange={(event) => {
                  const isNumber = checkNumberLimit(event.target.value);
                  if (isNumber) {
                    state.setDetails((s) => ({
                      ...s,
                      alternateContactNumber: event.target.value,
                    }));
                  }
                }}
                placeHolder={"add alternate Contact number"}
              />
            ) : (
              state.details.alternateContactNumber && (
                <TextView>
                  {"+91 " + state?.details?.alternateContactNumber}
                </TextView>
              )
            )}
          </Grid>
          <Grid item sm={2} marginLeft={"32px"}>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                color: "#4c5a6a",
                paddingBottom: "7px",
              }}
            >
              Email
            </Typography>
            {state.isEditable ? (
              <MuiInputField
                value={state?.details?.email}
                onChange={(event) => {
                  state.setDetails((s) => ({
                    ...s,
                    email: event.target.value,
                  }));
                }}
                placeHolder={"Add email id"}
              />
            ) : (
              <TextView>{state?.details?.email}</TextView>
            )}
          </Grid>
          <Grid item sm={3} marginLeft={"32px"}>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                color: "#4c5a6a",
                paddingBottom: "7px",
              }}
            >
              Reference Links
            </Typography>
            {state.isEditable ? (
              <MuiInputField
                value={state?.details?.referralLink}
                onChange={(event) => {
                  state.setDetails((s) => ({
                    ...s,
                    referralLink: event.target.value,
                  }));
                }}
                placeHolder={"Add reference Links"}
                multiline={true}
                rows={5}
              />
            ) : (
              urls?.map((url, index) => (
                <TextView isUrl={true} href={url} key={index}>
                  <a
                    style={{ textDecoration: "none" }}
                    target="_blank"
                    href={url}
                  >
                    {url}
                  </a>
                </TextView>
              ))
            )}
          </Grid>
        </Grid>
      </Box>
      {/* ) : (
        <HospitalView doc={doc} setDoc={setDoc} state={state}></HospitalView> */}
      {/* )} */}
      <Box
        border={state.isEditable ? "none" : "1px solid lightgrey"}
        borderRadius={2}
        marginTop={2}
        paddingX={5}
        paddingY={5}
      >
        <Typography
          sx={{
            fontWeight: "600",
            fontSize: "16px",
            color: "#4c5a6a",
            paddingBottom: "7px",
            paddingTop: "30px",
          }}
        >
          About Hospital
        </Typography>
        <Grid
          sx={{
            width: "100%",
            height: state.isEditable ? 300 : "auto",
            backgroundColor: state.isEditable ? "white" : "transparent",
            marginTop: "30px",
            border: state.isEditable ? "1px solid #e9eff7" : "none",
            borderRadius: "10px",
            marginBottom: "50px",
          }}
        >
          {state.isEditable ? (
            <TextEditor
              initialValue={state?.details?.about}
              onSave={(textValue) => {
                console.log("Text value:", textValue);
                state.setDetails((s) => ({
                  ...s,
                  about: textValue,
                }));
              }}
            />
          ) : (
            <TextView>{state?.details?.about || "N/A"}</TextView>
          )}
        </Grid>
        <Typography
          sx={{
            fontWeight: "600",
            fontSize: "16px",
            color: "#4c5a6a",
            paddingBottom: "7px",
            paddingTop: "30px",
          }}
        >
          Google Map Link
        </Typography>
        <Grid marginTop={"20px"} container justifyContent={"space-between"}>
          <Grid item sm={5}>
            {state.isEditable ? (
              <MuiInputField
                value={state?.details?.mapLink}
                onChange={(event) => {
                  state.setDetails((s) => ({
                    ...s,
                    mapLink: event.target.value,
                  }));
                }}
                placeHolder={"Add hospital map location"}
              />
            ) : (
              <DetailChip link value={state?.details?.mapLink}></DetailChip>
            )}
          </Grid>
          <Grid item sm={5}>
            {state.isEditable ? (
              <MuiInputField
                type="text"
                value={state?.details?.coordinates}
                onChange={(event) => {
                  state.setDetails((s) => ({
                    ...s,
                    coordinates: event.target.value,
                  }));
                }}
                placeHolder={"Eg:10.053826287297138, 76.35399518298661"}
              />
            ) : (
              <DetailChip
                value={state?.details?.coordinates || ""}
              ></DetailChip>
            )}
          </Grid>
          {/* <Grid item lg={1.4} container justifyContent={"flex-end"}>
            <MuiButton
              padding="10px 52px"
              viewHeight="45px"
              bgColor="#4c5a6a"
              borderRadius="5px"
              title={"Submit"}
            />
          </Grid> */}
        </Grid>

        <Grid marginTop={"20px"} container lg={12}>
          <Grid item lg={5}>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "16px",
                color: "#4c5a6a",
                paddingBottom: "20px",
                paddingTop: "20px",
              }}
            >
              Medical Departments
            </Typography>
            {state.isEditable ? (
              <MultiSelectDropDown
                handleSelected={(e, value) => {
                  state.setDetails((s) => ({
                    ...s,
                    departmentIds: value.map((val) => val.id),
                  }));
                  getTreatments(value.map((val) => val.id));
                  state.setDetails((s) => ({
                    ...s,
                    departmentListResponse: {
                      departments: value.map((val) => val),
                    },
                  }));
                }}
                placeholder="Choose Departments"
                data={state.departments || []}
                value={state.details.departmentListResponse.departments || []}
              />
            ) : state.details.departmentListResponse.departments.length ? (
              <Grid container item>
                {state.details.departmentListResponse.departments.map((val) => {
                  return (
                    <DetailChip key={val.id} value={val?.name}></DetailChip>
                  );
                })}
              </Grid>
            ) : (
              "N/A"
            )}
          </Grid>
          {treatments.length ? (
            <Grid item lg={5}>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "16px",
                  color: "#4c5a6a",
                  paddingBottom: "20px",
                  paddingTop: "20px",
                }}
              >
                Choose Treatments (for SEO)
              </Typography>
              {state.isEditable ? (
                <MultiSelectDropDown
                  handleSelected={(e, value) => {
                    state.setDetails((s) => ({
                      ...s,
                      topTreatmentIds: value.map((val) => val.id),
                    }));
                    state.setDetails((s) => ({
                      ...s,
                      treatmentListBasicResponse: {
                        treatments: value.map((val) => val),
                      },
                    }));
                  }}
                  placeholder="Choose Treatments"
                  data={treatments}
                  value={state.details.treatmentListBasicResponse.treatments}
                />
              ) : state.details?.treatmentListBasicResponse?.treatments
                ?.length ? (
                <Grid container item>
                  {state.details.treatmentListBasicResponse.treatments.map(
                    (val) => {
                      return <DetailChip value={val?.name}></DetailChip>;
                    }
                  )}
                </Grid>
              ) : (
                "N/A"
              )}
            </Grid>
          ) : null}
        </Grid>
      </Box>

      <DisApproveModal
        handleControl={handleControl}
        disApproveModal={disApproveModal}
        setDisApproveModal={setDisApproveModal}
        setRejectedReason={state?.setRejectedReason}
        error={state?.error}
        rejectedReason={state?.rejectedReason}
      />

      {state.isEditable && (
        <Grid
          marginTop={"20px"}
          container
          width={"100%"}
          justifyContent={"flex-end"}
        >
          <Grid item lg={1.8} container justifyContent={"flex-end"}>
            <MuiButton
              onClick={() => state.saveNewHospital()}
              padding="10px 52px"
              viewHeight="45px"
              bgColor="#17dfba"
              borderRadius="5px"
              title={"Save"}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};
